import React from 'react'
import * as yup from 'yup'
import * as Request from '../../utilities/request'
import { Staff } from '../../../../back-end/utilities/apiDefinitions'
import { Button, Col, Modal, Row } from 'react-bootstrap'
import { Formik } from 'formik'
import { FormText } from '../ui/Form/Text'

import './editStaffModal.css'
import { DateTime } from 'luxon'
import { FormDate } from '../ui/Form/Date'
import { AuthState } from '../../App.d'
interface OffboardStaffModalProps {
	authState: AuthState
	offboardStaff: Staff | null
	setOffboardStaff: React.Dispatch<React.SetStateAction<Staff | null>>
	allStaff: Staff[]
	setAllStaff: React.Dispatch<React.SetStateAction<Staff[]>>
}

const OffBoardStaffModal = (props: OffboardStaffModalProps) => {
	if (props.offboardStaff === null) {
		return null
	}

	const onHide = (isSubmitting: boolean) => {
		if (!isSubmitting) {
			props.setOffboardStaff(null)
		}
	}

	const onSubmit = async (values: Staff) => {
		const updateStaffRes = await Request.put(`staff?where=StaffID==${values.staffID}`, values)
		if (updateStaffRes.data.success) {
			props.setAllStaff(props.allStaff.map((staff) => (staff.staffID === values.staffID ? updateStaffRes.data.staff[0] : staff)))
			props.setOffboardStaff(null)
		}
	}

	const labelCol = 5
	const labelJustify = 'end'

	const StaffValidationSchema = yup.object().shape({
		terminationDate: yup.date().typeError('Termination date must be a valid date').nullable().required('Termination date is required'),
	})

	return (
		<Formik initialValues={props.offboardStaff} validationSchema={StaffValidationSchema} onSubmit={onSubmit}>
			{({ values, handleSubmit, isSubmitting, setFieldValue }) => (
				<Modal show={!!props.offboardStaff} onHide={() => onHide(isSubmitting)} dialogClassName={`offboard-staff-modal-lg`}>
					<Modal.Header>
						<Row className="align-items-center justify-content-between w-100">
							<Col sm="auto">
								<h4 className="m-0">{'Offboard Staff Member'}</h4>
							</Col>
						</Row>
					</Modal.Header>
					<Modal.Body className="staff-modal-body">
						<Row>
							<Col className="staff-modal-body">
								<FormText
									name="name"
									label="Staff Member Name"
									labelCol={labelCol}
									labelJustify={labelJustify}
									disabled
									readOnly
									value={`${values.name} (${values.email})`}
								/>
							</Col>
						</Row>
						<Row>
							{' '}
							<Col className="staff-modal-body">
								<FormDate
									label="Last Day"
									name="terminationDate"
									labelCol={labelCol}
									labelJustify={labelJustify}
									value={values.terminationDate ? DateTime.fromISO(values.terminationDate).toISODate() : null}
									onChange={(e) => setFieldValue('terminationDate', DateTime.fromISO(e.target.value, { zone: 'utc' }).toISO())}
								/>
							</Col>
						</Row>
					</Modal.Body>
					<Modal.Footer>
						<Row>
							<Col />

							{/* Right-aligned buttons */}
							<Col sm="auto">
								<Button variant="secondary" className="p-2" disabled={isSubmitting} onClick={() => onHide(isSubmitting)}>
									Cancel
								</Button>
							</Col>
							<Col sm="auto" className="p-0">
								<Button variant="primary" className="px-3 py-2" disabled={isSubmitting} onClick={() => handleSubmit()}>
									Save
								</Button>
							</Col>
						</Row>
					</Modal.Footer>
				</Modal>
			)}
		</Formik>
	)
}

export default OffBoardStaffModal
